import { styled as n, Box as u } from "@mui/material";
import { useCurrencyContext as d } from "../../currency-lib/contexts/CurrencyContext.js";
import g from "../../temp-lib/components/share/generic/IconText.js";
import { useAccountContext as y } from "../../temp-lib/contexts/account/AccountContext.js";
import * as r from "ramda";
import * as b from "ramda-adjunct";
import { jsx as o, Fragment as C } from "react/jsx-runtime";
const h = n(u)`
  background-color: #31333f;
  border-radius: 4px;
  border: 1px solid #ffffff44;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
  max-width: 400px;
  overflow: hidden;
  padding: 6px 12px;
`, w = n(g)`
  gap: 2px;

  .Custom-Text {
    color: #b1b3b3;
    font-size: 16px;
    font-weight: 300;

    strong {
      color: white;
      font-weight: 400;
      margin: 0px 4px;
    }
  }
  .Custom-Icon {
    width: 20px;
  }
`, F = (c) => {
  const {
    assetNames: e,
    className: a
  } = c, {
    getCurrencyByAssetName: s,
    getApeironPrice: p
  } = d(), {
    account: i
  } = y();
  return r.isNotEmpty(e) ? /* @__PURE__ */ o(h, {
    className: a,
    children: b.mapIndexed((m, f) => {
      const t = s(m);
      if (r.isNil(t))
        return null;
      const x = r.pathOr("0", ["balances", t.type, "amount"], i), l = `<strong>${p(t.type, x)}</strong>${t.name}`;
      return /* @__PURE__ */ o(w, {
        startSrc: t.image,
        text: l
      }, `currency-${f}`);
    }, e)
  }) : /* @__PURE__ */ o(C, {});
};
export {
  F as default
};
//# sourceMappingURL=ApeironCurrencyBalance.js.map
